import { Validator } from '@vista-digital/validator';
export var OccSeatingShape;
(function (OccSeatingShape) {
    OccSeatingShape["Round"] = "Round";
    OccSeatingShape["Rectangle"] = "Rectangle";
})(OccSeatingShape || (OccSeatingShape = {}));
export const occSeatingShapeValidator = Validator.oneOf(Object.values(OccSeatingShape));
//# sourceMappingURL=shape.js.map